<template>
	<div class='wms-main'>
		<div class="head">
			<div class="back" @click='goBack'>
				<img class="icon" src="@/assets/wms/back.png" alt="">
				<span class="text">返回上一层</span>
			</div>
		    <span class='head-title'>粮仓监管可视化大屏</span>
		</div>
		<div class="container">
			<ul class="menu">
				
				<li class="menu-item" @click='activeIndex=1'  :class="activeIndex==1?'active':''">视频监控</li>
				<li class="menu-item" @click='activeIndex=2'  :class="activeIndex==2?'active':''">粮情检测</li>
				<template v-if='activeIndex==1'>
					<el-select v-model="superviseId" placeholder="请输入或选择被监管方名称" filterable clearable
					    style="margin-left: 0.5rem;font-size:0.13rem" @change="getSupervise">
					    <el-option v-for="item in superviseList" :key="item.superviseId" :label="item.applyName" :value="item.superviseId">
					    </el-option>
					</el-select>
					<div class="watch-tabs">
						<div class="watch-tab" :class="pageSize==4?'active':''" @click='pageSize=4'>
							<span class="iconfont icon-fenping4"></span>
						</div>
						<div class="watch-tab" :class="pageSize==9?'active':''" @click='pageSize=9'>
							<span class="iconfont icon-fenping9"></span>
						</div>
						<div class="watch-tab" :class="pageSize==16?'active':''" @click='pageSize=16'>
							<span class="iconfont icon-fenping16"></span>
						</div>
					</div>
				</template>
				
			</ul>

			
				<watch v-if='activeIndex==1' :pageSize='pageSize' ref='watchChild'></watch>
				<detection v-if='activeIndex==2'></detection>
			
		</div>
	</div>
    
</template>

<script>
import watch from './watch'
import detection from './detection'
import {
    getData, getManyList,getSuperviseList
} from "@/api/wms/detection.js";
export default {
	components:{watch,detection},
    data() {
        return {
			activeIndex:'1',
			pageSize:4,
			superviseList: [],
			
			superviseId:''
			
			
			
        }
    },
	created() {
		// 获取被监管方名称
		this.getSuperviseList()
	},
	methods:{
		goBack(){
			this.$router.go(-2)
		},
		async getSuperviseList(){
		    const { data } = await getSuperviseList({})
		    if (data.result && data.result.length > 0) {
		        this.superviseList = data.result
		    }
		},
		getSupervise(val){
			this.$refs.watchChild.getWatchList(val)
			console.log(val)
		}
	}
	

};
</script>



<style lang="scss" scoped>
.wms-main{
	background: url(~@/assets/wms/bg.png);
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	
	.head{
		width: 100%;
		background: url(~@/assets/wms/header.png);
		height: 0.81rem;
		position: relative;
		text-align: center;
		.back{
			height: 0.81rem;
			position: absolute;
			left: 0;
			top: 0;
			display: flex;
			align-items: center;
			padding-left:0.16rem;
			    cursor: pointer;
			.icon{
				width: 0.55rem;
			}
			.text{
				font-size: 0.23rem;
				font-family: Source Han Sans-Medium, Source Han Sans;
				font-weight: 500;
				color: #FFFFFF;
				
				
			}
		}
		.head-title{
			
			font-size: 0.5rem;
			font-family: FZCuSong-B09S-Regular, FZCuSong-B09S;
			font-weight: 400;
			color: #19ECFF;
			height: 0.81rem;
			line-height: 0.81rem;
			letter-spacing: 9px;

		}
	}
	.container{
		height: 0;
		margin: 0.25rem;
		margin-top: 0.35rem;
		background: rgba(0,0,0,0.37);
		flex: 1;
		flex-direction: column;
		// border-radius: 0rem 0rem 0rem 0rem;
		opacity: 1;
		border: 0.01rem solid rgba(25,236,255,0.42);
		display: flex;
		.menu{
			padding-left: 0.38rem;
			padding-right: 0.28rem;
			padding-top: 0.2rem;
			display: flex;
			position:relative;
			.menu-item{
				height: 0.3rem;
				font-size: 0.18rem;
				font-family: Source Han Sans-Regular, Source Han Sans;
				font-weight: 400;
				color: rgba(255,255,255,0.98);
				line-height: 0.3rem;
				cursor: pointer;
				margin-right: 0.7rem;
			}
			>.active{
				font-size: 0.2rem;
				font-family: Source Han Sans-Bold, Source Han Sans;
				font-weight: 700;
				color: #19ECFF;
				position: relative;
			}
			>.active::after{
				content: '';
				position:absolute;
				bottom: -0.03rem;
				left:50%;
				transform: translateX(-50%);
				width: 0.5rem;
				height: 0.03rem;
				background: #19ECFF;
				border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
			}
			
			.watch-tabs{
				display: flex;
				align-items: center;
				color:rgb(205,207,214);
				position: absolute;
				    right: 0.38rem;
				.watch-tab{
					margin-left: 0.23rem;
					cursor: pointer;
				}
				.watch-tab.active{
					color: rgba(25, 236, 255, 1);
				}
			}
		}
	}
}
</style>
<style lang="scss" scoped>
	.el-menu{
		background-color: rgba(0,0,0,0);
		border-bottom:none;
	}
	.el-menu-item,.el-menu-item:hover{
		background-color: rgba(0,0,0,0) !important;
		font-size: 0.18rem !important;
		font-family: Source Han Sans-Regular, Source Han Sans !important;
		font-weight: 400 !important;
		color: rgba(255,255,255,0.98) !important;
	}
	.is-active,.is-active:hover{
		font-size: 0.2rem !important;
		font-family: Source Han Sans-Bold, Source Han Sans !important;
		font-weight: 700 !important;
		color: #19ECFF !important;
		// line-height: 0.3rem !important;
	}
	
	::v-deep .el-input__inner {
	    width: 3.25rem;
	    height: 0.4rem;
	    background: rgba(255, 255, 255, 0.08);
	    border: none;
	    border-radius: 0.03rem;
	    color: #FFFFFF !important;
	    font-size: .18rem !important;
	    border: 0.01rem solid rgba(255, 255, 255, 0.2);
	}
	
	// ::v-deep .search_input.el-input .el-input__inner {
	//     width: 2.25rem !important;
	// }
	
	::v-deep .el-input__icon {
	    color: #fff;
	}
	
	
	::v-deep .el-select .el-input .el-select__caret {
	    color: #fff !important;
	    line-height: .33rem;
	
	}
	
	.search_input>.el-input__inner {
	    padding: 0 0 0 .4rem;
	}
	
</style>

